import { render, staticRenderFns } from "./CellComponent.vue?vue&type=template&id=1ba80e62&scoped=true&"
import script from "./CellComponent.vue?vue&type=script&lang=js&"
export * from "./CellComponent.vue?vue&type=script&lang=js&"
import style0 from "./CellComponent.vue?vue&type=style&index=0&id=1ba80e62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba80e62",
  null
  
)

export default component.exports